/**
 * @mixin Search routing handling
 */
export default {
    data() {
        return {
            activeFilters: {},
            filterPath: '',
            mappings: this.$store.state.config.data.inputMappings,
            routerConfig: this.$store.state.config.data.router,
            setFromUrlFlag: false,
            totalItems: this.$store.state.config.data.total,
            totalPages: 1
        };
    },
    methods: {
        setUrlFetchData() {
            this.filterPath = '';
            Object.keys(this.filters).forEach((filter) => {
                let value = this.filters[filter];
                // if override -> strip default store values from url then
                // and if not empty
                // format then set as an activeFilter && add to url
                if ((typeof this.override === 'undefined' || !this.override || (this.override && value !== this.resetValues[filter])) &&
                    ((Array.isArray(value) && value.length) || (!Array.isArray(value) && value))) {
                    // run filters through search {gallery || profile} specific formatting
                    value = this.formatForUrl(filter, value);

                    // if filter == page place on end of path
                    if (filter === 'page') {
                        this.filters.page = value;
                    } else if (filter === 'max-results' || filter === 'start-index') {
                        return;
                    } else {
                        const translatedFilter = this.urlMapTranslate(filter);
                        let translatedValue = value;
                        if (filter === 'sort') {
                            translatedValue = this.urlMapTranslate(translatedValue);
                        }
                        this.filterPath += `/${translatedFilter}/${translatedValue}`;
                    }
                    this.activeFilters[filter] = value;
                } else if (typeof this.activeFilters[filter] !== 'undefined') {
                    // remove from local if previously set
                    delete this.activeFilters[filter];
                }
            });
            // foreach activeFilters -> stringify 'key/value' && if page > 1 add '/page/val'
            if (this.filters.page > 1) {
                this.filterPath += `/${this.routerConfig.part.page}/${this.filters.page}`;
            }

            window.history.pushState(this.activeFilters, '', `${this.routerConfig.page}${this.filterPath}`);
            this.formatFetchData();
        },
        formatForUrl(filter, value) {
            // Format filters for url
            switch (filter) {
                case 'height':
                case 'dob':
                    value = value.join('~');
                    break;
                case 'photos':
                case 'verified':
                case 'hotel':
                case 'travel':
                case 'accommodate':
                    value = value ? 1 : 0;
                    break;
                case 'sort':
                case 'distance':
                case 'location':
                case 'latitude':
                case 'longitude':
                case 'interest':
                case 'page':
                    break;
                default:
                    value = Array.isArray(value) ? value.join(',') : value;
                    break;
            }
            return value;
        },
        getUrlParams() {
            const url = window.location.pathname;
            // @todo regex to group key value pairs
            const urlParams = url.substr(1).split('/');
            urlParams.forEach((urlParam, index) => {
                urlParams[index] = decodeURIComponent(urlParam);
            });
            urlParams.shift();
            return urlParams;
        },
        setStoreFromUrl(urlParams, setActiveFilters = true) {
            if (this.override) {
                urlParams.shift();
            }
            // prepare data for Store
            this.setFromUrlFlag = true;
            if (setActiveFilters) {
                this.activeFilters = {};
            }
            let key = '';
            let value = '';
            urlParams.forEach((param, index) => {
                if (index % 2 !== 1) {
                    // reverse mapping translate
                    key = this.urlMapTranslate(param, true);
                } else {
                    value = param;
                    if (key === 'sort') {
                        value = this.urlMapTranslate(param, true);
                    }
                }
                if (setActiveFilters) {
                    this.activeFilters[key] = value;
                }
            });
            // set search {gallery || profile} vuex store values
            this.setFilterStore();
        },
        setFilterStore() {
            // Format filters for Store
            let value;
            const filters = {};
            Object.keys(this.activeFilters).forEach((key) => {
                value = this.activeFilters[key];
                switch (key) {
                    case 'extra':
                    case 'type':
                        value = value.split(',').map(Number);
                        break;
                    case 'height':
                    case 'dob':
                        value = value.split('~').map(Number);
                        break;
                    case 'latitude':
                    case 'longitude':
                        value = parseFloat(value);
                        break;
                    case 'location':
                        // convert url string '%20'
                        value = decodeURIComponent(value);
                        break;
                    case 'active':
                    case 'sort':
                    case 'smoke':
                        // do nothing with string
                        break;
                    case 'distance':
                    case 'page':
                        value = parseInt(value, 10);
                        break;
                    default:
                        value = value.split(',');
                        break;
                }
                filters[key] = value;
            });
            // Reset ALL filters then update with new filters
            this.$store.commit(`${this.store}/RESET_FILTERS`, filters);
        },
        urlMapTranslate(key, reverse = false) {
            const index = reverse ? 'foreign' : 'native';
            this.mappings.forEach((mapping) => {
                if (key === mapping[index]) {
                    const translation = reverse ? 'native' : 'foreign';
                    key = mapping[translation];
                }
            });
            return key;
        },
        formatFetchData() {
            const data = Object.assign({}, this.activeFilters);

            this.currentPageCheck(data);

            // get search {gallery || profile} results
            this.fetchData(data);
        },
        currentPageCheck(data) {
            data['max-results'] = this.showperpage;
            data.sort = this.filters.sort;

            // set page (max-results x (pageNum-1))
            if (data.page) {
                const pageMultiplier = data.page - 1; // offset by -1 so page 2 is x1 multiplier ( 0 x 25 = 0, 1 x 25 = 25)
                data['start-index'] = pageMultiplier * data['max-results'];
                delete data.page;
            } else {
                data['start-index'] = 0;
            }
        }
    },
    created() {
        this.totalPages = Math.ceil(this.totalItems / this.showperpage);
        const urlParams = this.getUrlParams();
        if (urlParams.length >= 2) {
            this.setStoreFromUrl(urlParams);
        }
        // browser navigation
        window.onpopstate = (event) => {
            this.activeFilters = Object.assign({}, event.state);
            this.setStoreFromUrl(this.getUrlParams(), false);
            this.formatFetchData();
        };
    },
    props: {
        showperpage: {
            // Show items per page
            type: Number, // 25, 50, 100
            required: true
        }
    },
    watch: {
        filters: {
            handler() {
                // If update triggered by user action
                if (!this.setFromUrlFlag) {
                    this.setUrlFetchData();
                }
                this.setFromUrlFlag = false;
            },
            deep: true
        },
        showperpage() {
            if (this.filters.page > 1) {
                this.setPage(1);
            } else {
                this.setUrlFetchData();
            }
        }
    }
};
